import '.l{width:100%;}.ssr-plugin'
import '.b6{max-width:100%;}.ssr-plugin'
import '.b7{margin-left:0px;}.ssr-plugin'
import '.b8{margin-right:0px;}.ssr-plugin'
import '.b9{margin-bottom:2rem;}.ssr-plugin'
import '.ba{height:auto;}.ssr-plugin'
import '.bb{overflow:hidden;}.ssr-plugin'
import '.bc{overflow-wrap:break-word;}.ssr-plugin'
import '.bd{word-break:break-word;}.ssr-plugin'
import sanitizeHtml from 'sanitize-html'
import parse, {
  DOMNode,
  domToReact,
  Element,
  type HTMLReactParserOptions,
} from 'html-react-parser'
import React from 'react'
import { Title } from '../typography/Title'
import { Paragraph } from '../typography/Paragraph'
import { UnorderedList } from '../typography/UnorderedList'
import { Quote } from '../typography/Quote'
import { styled } from 'inlines'
import { Image } from '../image/Image'
import { OrderedList } from '../typography/OrderedList'
import { TextLink } from '../link/TextLink'

type ComponentMap = {
  [tagName: string]: React.ComponentType<any>
}

interface SafeHtmlProps {
  html: string
  components?: ComponentMap
}

const Figure = ({ children }: { children: React.ReactNode }) => {
  return (
    <styled.figure className="l b6 b7 b8 b9 ba bb"
      style={{
        '& > img': {
          width: '100%',
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '1.25rem',
          display: 'block',
        },
      }}
    >
      {children}
    </styled.figure>
  )
}

const defaultComponents: ComponentMap = {
  h1: ({ children }) => <Title.H1>{children}</Title.H1>,
  h2: ({ children }) => <Title.H2>{children}</Title.H2>,
  h3: ({ children }) => <Title.H3>{children}</Title.H3>,
  h4: ({ children }) => <Title.H4>{children}</Title.H4>,
  h5: ({ children }) => <Title.H5>{children}</Title.H5>,
  p: ({ children }) => <Paragraph.Medium>{children}</Paragraph.Medium>,
  ul: ({ children }) => <UnorderedList>{children}</UnorderedList>,
  ol: ({ children }) => <OrderedList>{children}</OrderedList>,
  blockquote: ({ children }) => <Quote>{children}</Quote>,
  strong: ({ children }) => <strong>{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  a: ({ href, target, children }) => (
    <TextLink to={href ?? '#'} target={target}>
      {children}
    </TextLink>
  ),
  figure: ({ children }) => <Figure>{children}</Figure>,
  img: ({ src, alt }) => (
    <Image
      src={src}
      alt={alt}
      style={{
        maxWidth: '100%',
        width: 'auto',
        height: 'auto',
        display: 'block',
      }}
    />
  ),
}

export const SafeHtml = ({ html, components = {} }: SafeHtmlProps) => {
  const mergedComponents = {
    ...defaultComponents,
    ...components,
  }

  const cleanHtml = sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'img',
      'figure',
    ]),
    allowedAttributes: {
      '*': ['class'],
      a: ['href', 'target', 'rel'],
      img: ['src', 'alt'],
    },
    allowedSchemes: ['http', 'https', 'mailto'],
  })

  const parserOptions: HTMLReactParserOptions = {
    replace: (node) => {
      if (node instanceof Element) {
        const Component = mergedComponents[node.name]
        if (Component) {
          return (
            <Component {...node.attribs}>
              {domToReact(node.children as DOMNode[], parserOptions)}
            </Component>
          )
        }
      }
    },
  }

  return (
    <div className="l b6 bc bd"
    >
      {parse(cleanHtml, parserOptions)}
    </div>
  )
}
